// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let HistoricalBrokerMessageInfo = function ()
{
    this.ID = null
    this.TimeStamp = null
    this.ProductID = null
    this.Subject = null
    this.Message = null
    this.IsUnread = null
    this.ShowPopUp = null
    this.ResponseCases = null
    this.CustomButtons = null
    this.ClusterNode = null
    this.DisplayMethod = null
}